import { Themed, useThemeUI } from 'theme-ui';
import { DynamicSparkIcon } from '../../elements/spark-icons/dynamic-spark-icon';
import { Link } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var getStyles = function getStyles(element) {
  return "compounds.link-with-label.".concat(element);
};

export default (function (_ref) {
  var _theme$compounds$link, _theme$compounds$link2;

  var text = _ref.text,
      title = _ref.title,
      label = _ref.label,
      description = _ref.description,
      icon = _ref.icon,
      action = _ref.action;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  return _jsxs("div", {
    sx: {
      variant: getStyles('wrapper')
    },
    children: [label || description ? _jsxs("div", {
      sx: {
        variant: getStyles('column')
      },
      children: [_jsx(Themed.h5, {
        children: label
      }), _jsx(Themed.p, {
        children: description
      })]
    }) : null, _jsxs(Link, {
      className: action === '/account/signin' ? 'js-account-origin js-open-o-signin' : '',
      href: action,
      title: title,
      sx: {
        variant: getStyles('anchor')
      },
      children: [icon ? _jsx(DynamicSparkIcon, {
        glyph: icon,
        size: ((_theme$compounds$link = theme.compounds['link-with-label']) === null || _theme$compounds$link === void 0 ? void 0 : (_theme$compounds$link2 = _theme$compounds$link.icon) === null || _theme$compounds$link2 === void 0 ? void 0 : _theme$compounds$link2.size) || 'md'
      }) : null, _jsx("span", {
        children: text
      })]
    })]
  });
});
//# sourceMappingURL=index.js.map